"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifecycleNames = void 0;
exports.LifecycleNames = [
    "registerApp",
    "configureApp",
    "provision",
    "deploy",
    "publish",
];
//# sourceMappingURL=interface.js.map